import {Page} from './navigationStoreModel';

export class NavigationEvents {
    public static readonly pageActivated = 'pageActivated';
    public static readonly navigateRequested = 'navigateRequested';
}

export interface PageActivatedEvent {
    readonly page: Page;
}

export interface NavigateRequestedEvent {
    readonly path: string;
}
